import { oneWayData } from "Pages/AnalyzersV2/OneWay/@signals"

/**
 * What the rows of the table are: Direct Sites compares the webs of the execution, Broker the
 * brands inside one web.
 *
 * It is read back from the filters the response echoes, not from the live toggle: the table on
 * screen belongs to the last submit, and flipping the toggle without launching it again must
 * not relabel rows that were built the other way round.
 */
export const isOneWaySiteAxis = () => !oneWayData.value?.filters?.directSiteBrokerProvider

export const oneWayAxisLabel = () => isOneWaySiteAxis() ? 'Site' : 'Provider'
